export const DELETE_CONFIRM = (item?: string) => `Are you sure to delete ${item ? item : 'this'}`;
export const DECLINE_CONFIRM = (item: string) => `Are you sure to decline ${item ? item : 'this'}`;
export const DATA_SAVE = 'Data Saved';
export const DATA_UPDATE = 'Data Updated';
export const UPLOAD_FILE_FAILED = 'Failed to upload the file';
export const UPLOAD_FILE_REACT_SIZE_LIMIT = 'The file must smaller than 2MB!';
